import LandlordReconciliationDetailView from "../../components/LandlordReconciliationDetailView";


LandlordReconciliationDetailScreen.propTypes = {};

function LandlordReconciliationDetailScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <LandlordReconciliationDetailView />
        </div>
    );
}

export default LandlordReconciliationDetailScreen;
